import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=03a6d53f&scoped=true&"
import script from "./product-list.vue?vue&type=script&lang=js&"
export * from "./product-list.vue?vue&type=script&lang=js&"
import style0 from "./product-list.vue?vue&type=style&index=0&id=03a6d53f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6d53f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a6d53f')) {
      api.createRecord('03a6d53f', component.options)
    } else {
      api.reload('03a6d53f', component.options)
    }
    module.hot.accept("./product-list.vue?vue&type=template&id=03a6d53f&scoped=true&", function () {
      api.rerender('03a6d53f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/fee_rule_report/form/product-list.vue"
export default component.exports